/**
 * 606 Meta5 AI Trading - Badge Component
 */
import React from 'react';

const Badge = ({ children, variant = 'default', size = 'sm' }) => {
  const variants = {
    default: 'bg-white/10 text-white',
    success: 'bg-emerald-500/20 text-emerald-400',
    danger: 'bg-red-500/20 text-red-400',
    warning: 'bg-amber-500/20 text-amber-400',
    info: 'bg-blue-500/20 text-blue-400',
    gold: 'bg-[#d4af37]/20 text-[#d4af37]',
    buy: 'bg-emerald-500/20 text-emerald-400',
    sell: 'bg-red-500/20 text-red-400',
    high: 'bg-red-500/20 text-red-400',
    medium: 'bg-amber-500/20 text-amber-400',
    low: 'bg-blue-500/20 text-blue-400',
    bullish: 'bg-emerald-500/20 text-emerald-400',
    bearish: 'bg-red-500/20 text-red-400',
    neutral: 'bg-[#71717A]/20 text-[#71717A]',
  };
  
  const sizes = {
    xs: 'px-1.5 py-0.5 text-xs',
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
  };
  
  return (
    <span className={`inline-flex items-center rounded-full font-medium ${variants[variant]} ${sizes[size]}`}>
      {children}
    </span>
  );
};

export default Badge;
